import React, { useState } from "react";
import { Form, Input, Button, Row, Col, Modal } from 'antd';

export default function UpdSeat() {
    const [isModalOpen, setIsModalOpen ] = useState(false)
    const onFinish = async (values) => {
        console.log('Success:', values);

        let resp = await fetch('/update/seat', {
            method: 'PUT',
            body: JSON.stringify(values),
            headers: { 'Content-Type': 'application/json' },
        })
        let resp_data = await resp.json();
        if(resp_data.resp === 'ok'){
            showModal()
        }
    };
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    
    const showModal = () => {
        setIsModalOpen(true)
    }

    const handleModalResp = () => {
        setIsModalOpen(false)
    }
    
    return (
        <div>
            <Row style={{display:'flex', justifyContent:'center', alignItems:'center', width:'100vw',height:'100vh'}}>
                <Col span={24}>
                    <Form name="basic" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} style={{ maxWidth: 600 }} 
                        onFinish={onFinish} onFinishFailed={onFinishFailed} autoComplete="off"
                    >

                        <Form.Item wrapperCol={{ offset: 4, span: 20 }}>
                            <h3>Update Seat</h3>
                        </Form.Item>

                        <Form.Item label="Group" name="group" rules={[{ required: true, message: 'Please input your Group!' }]} >
                            <Input />
                        </Form.Item>

                        <Form.Item label="Seat" name="seat" rules={[{ required: true, message: 'Please input your Seat!' }]} >
                            <Input />
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                            <Button type="primary" htmlType="submit"> Update </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
            <Modal title="Update Seat" open={isModalOpen} onOk={handleModalResp} onCancel={handleModalResp} >
                <p>Seat Updated</p>
            </Modal>
        </div>
    );
}

